<div class="bl-padding-y--24 bl-max-width--desktop bl-margin-x--auto">
  <ea-custom-error
    errorType="404"
    [title]="'Looks like you\'ve lost your way. Let\'s get you back on track!'"
    [subTitle]="'Here are some helpful links:'"
    (action)="handleAction()"
    class="bl-margin-x--auto"
  >
    <ul class="bl-margin-y--8">
      <li class="bl-margin-bottom--8">
        <a routerLink="/user/dashboard" class="bl-font-weight--600 bl-font-size--22 bl-text-decoration--none">
          {{ '404-component/dashboard' | dictionary }}
        </a>
      </li>
      <li class="bl-margin-bottom--8">
        <a routerLink="/app/ola/ola-consumer-loan-type" class="bl-font-weight--600 bl-font-size--22 bl-text-decoration--none">
          {{ '404-component/loanApp' | dictionary }}
        </a>
      </li>
      <li class="bl-margin-bottom--8">
        <a routerLink="/app/oao/membership" class="bl-font-weight--600 bl-font-size--22 bl-text-decoration--none">
          {{ '404-component/membershipApp' | dictionary }}
        </a>
      </li>
    </ul>
  </ea-custom-error>
</div>
